var _style, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 40 40",
    style: {
      enableBackground: "new 0 0 40 40"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#139FDA;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M21.5,2.4c0.8-0.1,3.7-0.4,6,1.6c1.7,1.4,2.2,3.3,2.4,4.2c1.7,6.5-3.5,13.3-5.4,15.8c-1.6,2.1-4.6,5.9-9.8,8.1 c-2.3,1-6.3,2.7-10.1,0.9c-1.3-0.6-2.2-1.5-2.7-2.2c0.3,1,1.1,2.8,2.8,4c2.6,1.9,5.8,1.5,7.9,1.1c1.1-0.2,6.5-1.2,12.3-6.8 c1-0.9,11.3-11.2,8.7-21.1c-0.7-2.8-2.1-4.1-2.5-4.4C27.6,0.5,22.2,2.1,21.5,2.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M28.1,1.7c1.2,0,3.3,0.1,5.3,1.4c3.4,2.3,3.8,6.5,4,8.4c0.6,5.7-2.2,10.1-3.9,12.9c-3.5,5.7-8,8.6-9.7,9.6 c-2.8,1.6-9,5.4-15.3,3.3c-1.1-0.4-1.9-0.8-2.4-1.1c0.6,0.2,1.4,0.4,2.4,0.5c5.9,0.7,10.7-2.3,13.1-3.8c7.3-4.7,13-13.1,13.3-21.2 C35,9.7,35,6.6,32.8,4.2C31.3,2.5,29.2,1.9,28.1,1.7z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M37.1,7.6c0.4,0.9,1,2.2,1.3,3.8c1.2,5.8-1.5,10.6-2.9,13.2c-0.5,1-5.4,9.5-14.9,12.5c-3.1,1-6.2,1.3-6.3,1.1 c0-0.1,3.4-0.6,7-2.2c6.4-2.7,10.1-7.4,11.2-8.9c1.7-2.2,4.9-6.5,5.3-12.8C38.1,11.5,37.6,9.1,37.1,7.6z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M22.6,5.6c-1-0.1-2.7-0.1-4.6,0.4c-1.1,0.3-2.8,1-5.1,3.1c-1.1,1-8.2,7.4-6.8,14.2c0.2,1,0.5,2.2,1.5,3.1 c0,0,3.6,3.9,10.5-1c0.5-0.4-6.5,6-12.3,4.2c-0.7-0.2-2-0.6-3.1-1.9c-1.5-1.8-1.5-4-1.5-5C1.4,15.5,10.3,4.3,19.7,5 C21,5.1,22,5.4,22.6,5.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.e8ce20f26b654e59ecd13d4419ed4ef5.svg";
export { ForwardRef as ReactComponent };